var _defs, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 2000 2000",
    x: 0,
    y: 0,
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 264,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 264,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 200,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 264,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 328,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 392,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 584,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 200,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 456,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 200,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 264,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 328,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 456,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 520,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 584,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 648,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 200,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 264,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 392,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 328,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 392,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 520,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 584,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 648,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 264,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 328,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 392,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 264,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 392,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 584,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 200,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 456,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 648,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 328,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 392,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 584,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1416,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 968,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1224,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 904,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1352,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1544,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1288,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1480,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 712,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 776,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 840,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1032,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1096,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1160,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1608,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1672,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3.4 3.4",
    x: 1736,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    fill: "#aaaaaa",
    cx: 1.7,
    cy: 1.7,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 200,
    width: 448,
    height: 448,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M578.304,15.493c-30.441-4.132-60.883-7.437-91.322-9.916c-30.439-2.478-60.883-4.13-91.32-4.957   c-0.002,0-0.002,0-0.002,0c-30.441-0.826-60.881-0.826-91.322,0c-30.441,0.826-60.882,2.479-91.323,4.957   c-30.44,2.48-60.882,5.784-91.323,9.916c-30.441,4.13-60.882,9.088-91.324,14.872c-5.784,30.44-10.742,60.882-14.873,91.322   c-4.131,30.441-7.436,60.882-9.916,91.322C3.1,243.45,1.448,273.893,0.62,304.332c-0.827,30.442-0.827,60.884,0,91.324   c0.826,30.442,2.479,60.882,4.958,91.324c2.479,30.442,5.784,60.883,9.916,91.323c4.13,30.441,9.088,60.881,14.872,91.322   c30.441,5.781,60.882,10.739,91.324,14.87c30.44,4.135,60.881,7.438,91.323,9.914c30.441,2.48,60.881,4.132,91.323,4.958   c30.44,0.826,60.881,0.826,91.321,0c0.002,0,0.002,0,0.002,0c30.439-0.826,60.881-2.479,91.32-4.958   c30.439-2.479,60.883-5.78,91.324-9.914c30.438-4.131,60.881-9.089,91.318-14.87c5.783-30.441,10.74-60.881,14.871-91.322   c4.133-30.44,7.439-60.881,9.916-91.323c2.48-30.441,4.131-60.881,4.957-91.324c0.826-30.441,0.826-60.882,0-91.324   c-0.824-30.438-2.479-60.882-4.957-91.321c-2.479-30.441-5.783-60.882-9.916-91.323c-4.131-30.44-9.088-60.882-14.871-91.322   C639.185,24.581,608.744,19.624,578.304,15.493z M596.01,206.636c1.771,31.855,2.949,63.714,3.543,95.569   c0.59,31.858,0.59,63.716,0,95.575c-0.594,31.858-1.771,63.714-3.543,95.573c-1.77,31.857-4.131,63.716-7.08,95.573   c-31.857,2.95-63.719,5.311-95.574,7.082c-31.857,1.771-63.713,2.95-95.568,3.541c-0.002,0-0.002,0-0.002,0   c-31.855,0.59-63.713,0.59-95.571,0c-31.858-0.591-63.716-1.771-95.573-3.541c-31.857-1.771-63.715-4.133-95.572-7.082   c-2.951-31.857-5.312-63.716-7.083-95.573c-1.771-31.858-2.951-63.714-3.542-95.573s-0.59-63.716,0-95.575   c0.59-31.856,1.771-63.715,3.541-95.569c1.771-31.858,4.132-63.716,7.083-95.572c31.857-2.95,63.714-5.313,95.573-7.081   c31.856-1.772,63.714-2.952,95.573-3.542c31.856-0.592,63.711-0.592,95.571,0c0,0,0,0,0.002,0   c31.855,0.59,63.711,1.77,95.568,3.542c31.855,1.771,63.717,4.132,95.574,7.081C591.879,142.922,594.238,174.778,596.01,206.636z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 200,
    width: 448,
    height: 448,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M395.865,201.374L395.865,201.374c-30.58-1.835-61.162-1.835-91.741,0   c-30.581,1.834-61.162,5.504-91.741,11.009c-5.505,30.58-9.174,61.161-11.009,91.74c-1.835,30.581-1.835,61.162,0,91.742   c1.834,30.581,5.504,61.16,11.009,91.74c30.581,5.504,61.161,9.174,91.741,11.01c30.58,1.834,61.161,1.834,91.741,0l0,0   c30.58-1.836,61.16-5.506,91.74-11.01c5.504-30.58,9.174-61.159,11.01-91.74c1.834-30.58,1.834-61.162,0-91.742   c-1.836-30.58-5.506-61.161-11.01-91.74C457.025,206.878,426.445,203.208,395.865,201.374z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1352,
    y: 200,
    width: 448,
    height: 448,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M578.304,15.493c-30.441-4.132-60.883-7.437-91.322-9.916c-30.439-2.478-60.883-4.13-91.32-4.957   c-0.002,0-0.002,0-0.002,0c-30.441-0.826-60.881-0.826-91.322,0c-30.441,0.826-60.882,2.479-91.323,4.957   c-30.44,2.48-60.882,5.784-91.323,9.916c-30.441,4.13-60.882,9.088-91.324,14.872c-5.784,30.44-10.742,60.882-14.873,91.322   c-4.131,30.441-7.436,60.882-9.916,91.322C3.1,243.45,1.448,273.893,0.62,304.332c-0.827,30.442-0.827,60.884,0,91.324   c0.826,30.442,2.479,60.882,4.958,91.324c2.479,30.442,5.784,60.883,9.916,91.323c4.13,30.441,9.088,60.881,14.872,91.322   c30.441,5.781,60.882,10.739,91.324,14.87c30.44,4.135,60.881,7.438,91.323,9.914c30.441,2.48,60.881,4.132,91.323,4.958   c30.44,0.826,60.881,0.826,91.321,0c0.002,0,0.002,0,0.002,0c30.439-0.826,60.881-2.479,91.32-4.958   c30.439-2.479,60.883-5.78,91.324-9.914c30.438-4.131,60.881-9.089,91.318-14.87c5.783-30.441,10.74-60.881,14.871-91.322   c4.133-30.44,7.439-60.881,9.916-91.323c2.48-30.441,4.131-60.881,4.957-91.324c0.826-30.441,0.826-60.882,0-91.324   c-0.824-30.438-2.479-60.882-4.957-91.321c-2.479-30.441-5.783-60.882-9.916-91.323c-4.131-30.44-9.088-60.882-14.871-91.322   C639.185,24.581,608.744,19.624,578.304,15.493z M596.01,206.636c1.771,31.855,2.949,63.714,3.543,95.569   c0.59,31.858,0.59,63.716,0,95.575c-0.594,31.858-1.771,63.714-3.543,95.573c-1.77,31.857-4.131,63.716-7.08,95.573   c-31.857,2.95-63.719,5.311-95.574,7.082c-31.857,1.771-63.713,2.95-95.568,3.541c-0.002,0-0.002,0-0.002,0   c-31.855,0.59-63.713,0.59-95.571,0c-31.858-0.591-63.716-1.771-95.573-3.541c-31.857-1.771-63.715-4.133-95.572-7.082   c-2.951-31.857-5.312-63.716-7.083-95.573c-1.771-31.858-2.951-63.714-3.542-95.573s-0.59-63.716,0-95.575   c0.59-31.856,1.771-63.715,3.541-95.569c1.771-31.858,4.132-63.716,7.083-95.572c31.857-2.95,63.714-5.313,95.573-7.081   c31.856-1.772,63.714-2.952,95.573-3.542c31.856-0.592,63.711-0.592,95.571,0c0,0,0,0,0.002,0   c31.855,0.59,63.711,1.77,95.568,3.542c31.855,1.771,63.717,4.132,95.574,7.081C591.879,142.922,594.238,174.778,596.01,206.636z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1352,
    y: 200,
    width: 448,
    height: 448,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M395.865,201.374L395.865,201.374c-30.58-1.835-61.162-1.835-91.741,0   c-30.581,1.834-61.162,5.504-91.741,11.009c-5.505,30.58-9.174,61.161-11.009,91.74c-1.835,30.581-1.835,61.162,0,91.742   c1.834,30.581,5.504,61.16,11.009,91.74c30.581,5.504,61.161,9.174,91.741,11.01c30.58,1.834,61.161,1.834,91.741,0l0,0   c30.58-1.836,61.16-5.506,91.74-11.01c5.504-30.58,9.174-61.159,11.01-91.74c1.834-30.58,1.834-61.162,0-91.742   c-1.836-30.58-5.506-61.161-11.01-91.74C457.025,206.878,426.445,203.208,395.865,201.374z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 1352,
    width: 448,
    height: 448,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M578.304,15.493c-30.441-4.132-60.883-7.437-91.322-9.916c-30.439-2.478-60.883-4.13-91.32-4.957   c-0.002,0-0.002,0-0.002,0c-30.441-0.826-60.881-0.826-91.322,0c-30.441,0.826-60.882,2.479-91.323,4.957   c-30.44,2.48-60.882,5.784-91.323,9.916c-30.441,4.13-60.882,9.088-91.324,14.872c-5.784,30.44-10.742,60.882-14.873,91.322   c-4.131,30.441-7.436,60.882-9.916,91.322C3.1,243.45,1.448,273.893,0.62,304.332c-0.827,30.442-0.827,60.884,0,91.324   c0.826,30.442,2.479,60.882,4.958,91.324c2.479,30.442,5.784,60.883,9.916,91.323c4.13,30.441,9.088,60.881,14.872,91.322   c30.441,5.781,60.882,10.739,91.324,14.87c30.44,4.135,60.881,7.438,91.323,9.914c30.441,2.48,60.881,4.132,91.323,4.958   c30.44,0.826,60.881,0.826,91.321,0c0.002,0,0.002,0,0.002,0c30.439-0.826,60.881-2.479,91.32-4.958   c30.439-2.479,60.883-5.78,91.324-9.914c30.438-4.131,60.881-9.089,91.318-14.87c5.783-30.441,10.74-60.881,14.871-91.322   c4.133-30.44,7.439-60.881,9.916-91.323c2.48-30.441,4.131-60.881,4.957-91.324c0.826-30.441,0.826-60.882,0-91.324   c-0.824-30.438-2.479-60.882-4.957-91.321c-2.479-30.441-5.783-60.882-9.916-91.323c-4.131-30.44-9.088-60.882-14.871-91.322   C639.185,24.581,608.744,19.624,578.304,15.493z M596.01,206.636c1.771,31.855,2.949,63.714,3.543,95.569   c0.59,31.858,0.59,63.716,0,95.575c-0.594,31.858-1.771,63.714-3.543,95.573c-1.77,31.857-4.131,63.716-7.08,95.573   c-31.857,2.95-63.719,5.311-95.574,7.082c-31.857,1.771-63.713,2.95-95.568,3.541c-0.002,0-0.002,0-0.002,0   c-31.855,0.59-63.713,0.59-95.571,0c-31.858-0.591-63.716-1.771-95.573-3.541c-31.857-1.771-63.715-4.133-95.572-7.082   c-2.951-31.857-5.312-63.716-7.083-95.573c-1.771-31.858-2.951-63.714-3.542-95.573s-0.59-63.716,0-95.575   c0.59-31.856,1.771-63.715,3.541-95.569c1.771-31.858,4.132-63.716,7.083-95.572c31.857-2.95,63.714-5.313,95.573-7.081   c31.856-1.772,63.714-2.952,95.573-3.542c31.856-0.592,63.711-0.592,95.571,0c0,0,0,0,0.002,0   c31.855,0.59,63.711,1.77,95.568,3.542c31.855,1.771,63.717,4.132,95.574,7.081C591.879,142.922,594.238,174.778,596.01,206.636z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 1352,
    width: 448,
    height: 448,
    viewBox: "0 0 699.988 699.988",
    enableBackground: "new 0 0 699.988 699.988",
    xmlSpace: "preserve",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M395.865,201.374L395.865,201.374c-30.58-1.835-61.162-1.835-91.741,0   c-30.581,1.834-61.162,5.504-91.741,11.009c-5.505,30.58-9.174,61.161-11.009,91.74c-1.835,30.581-1.835,61.162,0,91.742   c1.834,30.581,5.504,61.16,11.009,91.74c30.581,5.504,61.161,9.174,91.741,11.01c30.58,1.834,61.161,1.834,91.741,0l0,0   c30.58-1.836,61.16-5.506,91.74-11.01c5.504-30.58,9.174-61.159,11.01-91.74c1.834-30.58,1.834-61.162,0-91.742   c-1.836-30.58-5.506-61.161-11.01-91.74C457.025,206.878,426.445,203.208,395.865,201.374z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeQr);
export default __webpack_public_path__ + "static/media/ResumeQR.faed0d083b5e5ecd977599a31af4b5ef.svg";
export { ForwardRef as ReactComponent };